const HUB_SCROLL_IDLE_MS = 900;

const HUB_SCROLL_SELECTOR =
	".wrap, .task-col-body, .task-board-viewport, .task-list-scroll, .table-wrap, .side-scroll";

/** Thin scrollbars that appear while scrolling (same idea as webmail). */
export function bindHubScrollFade(hubRoot: HTMLElement | null): () => void {
	if (!hubRoot) return () => {};

	const timers = new WeakMap<EventTarget, number>();

	const markScrollable = () => {
		for (const node of hubRoot.querySelectorAll(HUB_SCROLL_SELECTOR)) {
			if (node instanceof HTMLElement) node.classList.add("hub-scroll");
		}
	};

	markScrollable();

	const onScroll = (event: Event) => {
		const el = event.target;
		if (!(el instanceof HTMLElement) || !el.classList.contains("hub-scroll")) return;
		el.classList.add("is-scrolling");
		const prev = timers.get(el);
		if (prev !== undefined) window.clearTimeout(prev);
		const timer = window.setTimeout(() => {
			el.classList.remove("is-scrolling");
			timers.delete(el);
		}, HUB_SCROLL_IDLE_MS);
		timers.set(el, timer);
	};

	hubRoot.addEventListener("scroll", onScroll, { capture: true, passive: true });

	const observer = new MutationObserver(() => markScrollable());
	observer.observe(hubRoot, { childList: true, subtree: true });

	return () => {
		hubRoot.removeEventListener("scroll", onScroll, { capture: true });
		observer.disconnect();
		for (const node of hubRoot.querySelectorAll(`${HUB_SCROLL_SELECTOR}.is-scrolling`)) {
			if (node instanceof HTMLElement) node.classList.remove("is-scrolling");
		}
	};
}
